import { Controller } from "@hotwired/stimulus"

// Stimulus controller for the firmware upload form. Two responsibilities:
//   1. On file selection, render a small preview (filename + human-readable
//      size) next to the input so the operator can double-check what they
//      picked before hitting submit.
//   2. On form submit, disable the submit button and swap its label to a
//      "uploading" state so a double-click can't fire a second POST while
//      the first upload is still in flight.
//
// Deliberately does NOT hijack the submit into an XHR: the form is a plain
// multipart/form-data POST, and full-page reload after upload is the exact
// UX the rest of the admin surface uses. Adding a progress bar would need
// XHR/fetch with upload progress events plus a Turbo Stream response
// endpoint — out of scope for this slice.
export default class extends Controller {
  static targets = ["input", "preview", "filename", "size", "submit"]
  static values = { uploadingLabel: String }

  fileSelected() {
    const file = this.inputTarget.files?.[0]
    if (!file) {
      this.previewTarget?.classList.add("hidden")
      return
    }
    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name
    if (this.hasSizeTarget)
      this.sizeTarget.textContent = this.humanSize(file.size)
    this.previewTarget?.classList.remove("hidden")
  }

  submitting() {
    if (!this.hasSubmitTarget) return
    this.submitTarget.disabled = true
    if (this.uploadingLabelValue) {
      this.submitTarget.textContent = this.uploadingLabelValue
    }
  }

  humanSize(bytes) {
    if (bytes < 1024) return `${bytes} B`
    const units = ["KB", "MB", "GB"]
    let n = bytes / 1024
    let i = 0
    while (n >= 1024 && i < units.length - 1) {
      n /= 1024
      i += 1
    }
    return `${n.toFixed(1)} ${units[i]}`
  }
}
